import { STTypoModels } from '@protector/components';

export type TypeOptions = STTypoModels.TypeOptions;
export const TypeOptions = STTypoModels.TypeOptions;
export type CssAlignTypo = STTypoModels.CssAlignTypo;
export type FontFamily = STTypoModels.FontFamily;
export type STTypoProps<T extends FontFamily = 'Rubik'> = STTypoModels.STTypoProps<T>;
